__webpack_require__.p = "https://rb-8bs.pages.dev/";